import React, { Suspense } from 'react';
import LoadingPage from './LoadingPage';
import Header from '../haeder/Header';
import Footer from '../footer/Footer';
import { Outlet } from 'react-router-dom';

const HeaderFPage = () => {
    return (
        <Suspense fallback={<LoadingPage />}>
            <Header />
            <Outlet />
            <Footer />
        </Suspense>
    );
};

export default HeaderFPage;